module.exports = __webpack_public_path__ + "img/spear-zagreus.bdd86c28.jpg";